import { TMessage } from '../types';

// oxlint-disable-next-line typescript/no-explicit-any
export function isValidMessage(message: any): message is TMessage {
  if (!message || typeof message !== 'object') {
    return false;
  }

  return 'value' in message && 'type' in message && ['reduxAction', 'analytics'].includes(message.type);
}
